/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import * as S from '../../styles';

export interface ISelectInputProps {
    id: string;
    fontScale?: number;

    label?: string;
    labelColor?: string;
    errorText?: string;
    readOnly?: boolean;
    disabled?: boolean;
    options?: { id: string; label: string }[];
    value?: string;
    required?: boolean;
    placeholder?: string;
    addOnValidation?: any;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
}

export const SelectInput = ({
    id,
    fontScale,

    label,
    labelColor,
    options,
    errorText,
    value,
    required,
    placeholder,
    onCompChange,
    hasError,
    readOnly,
    disabled,
}: ISelectInputProps) => {
    const [textValue, setTextValue] = useState(value ?? '');
    const [isInvalid, setInvalid] = useState(false);
    useEffect(() => setTextValue(value ?? ''), [value]);

    console.log('ki->', isInvalid, '.', hasError, '.', errorText);
    useEffect(() => {
        setInvalid(hasError);
    }, [hasError]);
    const onChange = (id: string, e: any) => {
        setTextValue(e?.target?.value);
        onCompChange && onCompChange(id, e?.target?.value);
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    document.getElementById(`input-${id}`)?.addEventListener('focusin', (e) => {
        console.log(e, 'moi->');
        document
            .getElementById(`input-group-${id}`)
            ?.classList.add('input-group-ch');
    });
    document
        .getElementById(`input-${id}`)
        ?.addEventListener('focusout', (e) => {
            console.log(e, 'moi->');
            document
                .getElementById(`input-group-${id}`)
                ?.classList.remove('input-group-ch');
        });

    return (
        console.log('insideeesleect', textValue),
        (
            <>
                <Form.Group id={id} className=" formgroup">
                    {_renderLabelIf()}
                    <InputGroup
                        id={`input-group-${id}`}
                        className="input-group-bt"
                    >
                        <S.FormSelect
                            className="formcontrol shadow-none"
                            value={textValue}
                            onChange={onChange.bind(null, id)}
                            required={required}
                            as="select"
                            placeholder={placeholder}
                            fontScale={fontScale}
                            readOnly={readOnly}
                            disabled={readOnly}
                            id={`input-${id}`}
                            isInvalid={isInvalid}
                        >
                            <option value="none">Select options</option>
                            {options &&
                                Array?.isArray(options) &&
                                options?.map(
                                    (option: { id: string; label: string }) => (
                                        <option
                                            key={`tweety-option-${option.id}`}
                                            value={option.id}
                                        >
                                            {option.label}
                                        </option>
                                    )
                                )}
                        </S.FormSelect>
                    </InputGroup>
                    {/* <ArrowDownwardOutlined /> */}
                    {_renderErrorTextIf()}
                </Form.Group>
            </>
        )
    );
};

SelectInput.defaultProps = {
    required: false,
    hasError: false,
    readOnly: false,
};
